import { Skeleton } from "../../shadcn/skeleton";

const ProductFilterSystemSkeleton = () => {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex-1 flex items-center gap-2 overflow-hidden">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-9 w-20 rounded-md shrink-0" />
        ))}
      </div>
      <Skeleton className="h-9 w-44 rounded-md shrink-0" />
    </div>
  );
};

export default ProductFilterSystemSkeleton;
